if (!customElements.get('scarlet-responsive-video')) {
  class ScarletResponsiveVideo extends HTMLElement {
    connectedCallback() {
      if (this.video) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      this.mobileQuery = window.matchMedia('(max-width: 768px)');
      this.video = document.createElement('video');
      this.video.autoplay = true;
      this.video.loop = true;
      this.video.muted = true;
      this.video.playsInline = true;
      this.video.preload = 'metadata';
      this.video.setAttribute('aria-hidden', 'true');

      this.handlePlaying = () => this.classList.add('is-playing');
      this.handleBreakpointChange = () => this.loadSelectedVideo();

      this.video.addEventListener('playing', this.handlePlaying);
      this.mobileQuery.addEventListener('change', this.handleBreakpointChange);
      this.appendChild(this.video);
      this.loadSelectedVideo();
    }

    disconnectedCallback() {
      if (!this.video) return;

      this.video.pause();
      this.video.removeEventListener('playing', this.handlePlaying);
      this.mobileQuery.removeEventListener('change', this.handleBreakpointChange);
      this.video.remove();
      this.video = null;
    }

    loadSelectedVideo() {
      const prefix = this.mobileQuery.matches ? 'mobile' : 'desktop';
      const sourceUrl = this.dataset[`${prefix}Src`] || this.dataset.desktopSrc;
      const sourceType = this.dataset[`${prefix}Type`] || this.dataset.desktopType || 'video/mp4';

      if (!sourceUrl || this.video.dataset.sourceUrl === sourceUrl) return;

      this.classList.remove('is-playing');
      this.video.pause();
      this.video.replaceChildren();

      const source = document.createElement('source');
      source.src = sourceUrl;
      source.type = sourceType;
      this.video.appendChild(source);
      this.video.dataset.sourceUrl = sourceUrl;
      this.video.load();

      const playPromise = this.video.play();
      if (playPromise) playPromise.catch(() => {});
    }
  }

  customElements.define('scarlet-responsive-video', ScarletResponsiveVideo);
}
